import React, { useEffect, useState } from 'react'
import Topbar from '../../Components/Topbar'
import LeftbarUser from '../../Components/LeftbarUser'
import BottomNavUser from '../../Components/BottomNavUser'
import { useParams, useNavigate } from 'react-router-dom'
import { Modal, Button, Form } from 'react-bootstrap';
import {
    getFirestore,
    doc,
    getDoc,
    collection,
    query,
    where,
    getDocs,
    updateDoc,
    arrayUnion
} from 'firebase/firestore'
import { app } from '../../firebase'
import Spinner from 'react-bootstrap/Spinner'
import defaultProfile from '../../Images/def.png'
import { saveAs } from "file-saver"
import swal from 'sweetalert';
import { Link } from 'react-router-dom'

function UserViewSubs() {
    const { adId } = useParams()
    const navigate = useNavigate()
    const db = getFirestore(app)

    const [loading, setLoading] = useState(true)
    const [adData, setAdData] = useState(null)
    const [advertiser, setAdvertiser] = useState(null)
    const [incomeData, setIncomeData] = useState(null)
      useEffect(() => {
        document.title = "Zindua App | Dashboard";
    
        // Meta description
        let desc = document.querySelector("meta[name='description']");
        if (!desc) {
          desc = document.createElement("meta");
          desc.setAttribute("name", "description");
          document.head.appendChild(desc);
        }
        desc.setAttribute("content", "Zindua App dashboard");
    
        // Open Graph tags
        const ogTags = [
          { property: "og:title", content: "Zindua App | Dashboard" },
          { property: "og:description", content: "Zindua App Dashboard" },
          { property: "og:type", content: "website" },
          { property: "og:url", content: "https://zindua.app/dashboard" },
          { property: "og:image", content: "https://zindua.app/logo192.png" },
        ];
    
        ogTags.forEach(({ property, content }) => {
          let tag = document.querySelector(`meta[property='${property}']`);
          if (!tag) {
            tag = document.createElement("meta");
            tag.setAttribute("property", property);
            document.head.appendChild(tag);
          }
          tag.setAttribute("content", content);
        });
    
        // JSON-LD structured data
        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.text = JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Zindua App Influencer Dashboard",
          "url": "https://zindua.app/dashboard",
          "description": "Zindua App influencer dashboard where you can manage your earnings, running ads, subscriptions, and withdraw funds to M-Pesa.",
          "inLanguage": "en",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://zindua.app/"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Dashboard",
                "item": "https://zindua.app/dashboard"
              }
            ]
          }
        });
        document.head.appendChild(script);
    
        return () => {
          document.head.removeChild(script);
        };
      }, []);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true)

            try {
                const adRef = doc(db, 'subscriptions', adId)
                const adSnap = await getDoc(adRef)

                if (!adSnap.exists()) {
                    setLoading(false)
                    return
                }

                const ad = adSnap.data()
                setAdData(ad)

                if (ad.influencerId) {
                    const userRef = doc(db, 'users', ad.influencerId)
                    const userSnap = await getDoc(userRef)
                    if (userSnap.exists()) {
                        setAdvertiser(userSnap.data())
                    }
                }

                const incomeRef = collection(db, 'income')
                const q = query(incomeRef, where('adID', '==', adId))
                const incomeSnap = await getDocs(q)

                if (!incomeSnap.empty) {
                    setIncomeData(incomeSnap.docs[0].data())
                }

            } catch (error) {
                console.error(error)
            }

            setLoading(false)
        }

        fetchData()
    }, [adId, db])

    const capitalize = value => {
        if (!value || typeof value !== 'string') return ''
        return value.charAt(0).toUpperCase() + value.slice(1)
    }

    const formatAdType = type => {
        if (!type) return ''
        if (type === 'cgc') return 'Creator Generated Content'
        if (type === 'post') return 'Post'
        if (type === 'story') return 'Story'
        return capitalize(type)
    }



    const getSubscriptionStatus = (expiryDate) => {
        if (!expiryDate) return "Unknown"

        const now = new Date()
        const expiry = expiryDate.toDate()

        return expiry > now ? "Active" : "Expired"
    }

    const handleSubmitReport = () => {
        if (!adData?.influencerId) return

        navigate("/user/messages", {
            state: {
                receiverId: adData.influencerId,
                adId: adId,
                context: "subscription"
            }
        })


    }

    const [showReportModal, setShowReportModal] = useState(false)
    const [reportType, setReportType] = useState('')
    const [reportMessage, setReportMessage] = useState('')
    const [reports, setReports] = useState([])
    const [submittingReport, setSubmittingReport] = useState(false)


    const handleReportSubmit = async () => {
        if (!reportType) {
            swal("Missing info", "Please select a report reason", "warning")
            return
        }

        try {
            setSubmittingReport(true)

            const adRef = doc(db, 'subscriptions', adId)

            await updateDoc(adRef, {
                reports: arrayUnion({
                    type: reportType,
                    message: reportMessage,
                    reportedBy: adData.userId || "anonymous",
                    createdAt: new Date()
                })
            })

            setReports(prev => [
                ...prev,
                {
                    type: reportType,
                    message: reportMessage,
                    createdAt: new Date()
                }
            ])

            setShowReportModal(false)
            setReportType('')
            setReportMessage('')

            swal("Submitted", "Your report has been submitted", "success")
        } catch (err) {
            console.error(err)
            swal("Error", "Could not submit report", "error")
        } finally {
            setSubmittingReport(false)
        }
    }




    if (loading) {
        return (
            <div className="mainDashboard">
                <div className="desktopOnly">
                    <LeftbarUser />
                </div>
                <div className="mainContent">
                    <Topbar />
                    <div style={{ padding: '20px', textAlign: 'center' }}>
                        <Spinner animation="border" />
                    </div>
                </div>
                <div className="mobileOnly">
                    <BottomNavUser />
                </div>
            </div>
        )
    }

    if (!adData) {
        return (
            <div className="mainDashboard">
                <div className="desktopOnly">
                    <LeftbarUser />
                </div>
                <div className="mainContent">
                    <Topbar />
                    <div style={{ padding: '20px', textAlign: 'center' }}>
                        <p>subscription not found</p>
                    </div>
                </div>
                <div className="mobileOnly">
                    <BottomNavUser />
                </div>
            </div>
        )
    }


    return (
        <div className='mainDashboard'>

            <div className="desktopOnly">
                <LeftbarUser />
            </div>

            <div className="mainContent">
                <Topbar />

                <section className="adDetailPage container mt-3">
                    <div className="adDetailPageTop">
                        <h5>
                            {adData.brandName}{' '}
                            <span className="adDetailSpan">
                                {getSubscriptionStatus(adData.expiryDate)}
                            </span>
                        </h5>

                        {getSubscriptionStatus(adData.expiryDate) === "Active" && (
                            <button className="approveAd" onClick={handleSubmitReport} >
                                View Reports
                            </button>
                        )}
                    </div>

                    <div className="adDetailPageTopTwo">
                        <p>
                            <strong>Months Subscribed</strong>{' '}
                            {adData.months}{' '}
                        </p>

                        <p>
                            <strong>Subscription Amount:</strong>{' '}
                            {incomeData
                                ? `KES ${Number(incomeData.totalCost).toLocaleString()}`
                                : '-'}
                        </p>


                        <p>
                            <strong>Subscription Status:</strong>{' '}
                            {getSubscriptionStatus(adData.expiryDate)}
                        </p>
                    </div>

                    <div className="adDetailPageCont">
                        <div className="adDetailPageLeft">
                            <p><strong>Business Category:</strong> {adData.businessCategory}</p>
                            <p><strong>Ad Purpose:</strong> {adData.adPurpose}</p>
                            <p><strong>What the business does:</strong> {adData.businessDesc}</p>
                            <p><strong>Website or Social Link:</strong> {adData.websiteLink}</p>

                            {adData.cgcDetails && (
                                <p>
                                    <strong>Content Guidelines:</strong><br />
                                    {adData.cgcDetails}
                                </p>
                            )}

                            {adData.uploadedFiles && adData.uploadedFiles.length > 0 && (
                                <p>
                                    <strong>Uploaded file type:</strong>{' '}
                                    {capitalize(adData.uploadType)}
                                </p>
                            )}

                            {adData.postCaption && (
                                <p>
                                    <strong>Post Caption:</strong><br />
                                    {adData.postCaption}
                                </p>
                            )}

                            <p>
                                <strong>Submitted On:</strong>{' '}
                                {adData.timestamp?.toDate().toLocaleString()}
                            </p>

                            <p>
                                <strong>Expiry Date:</strong>{' '}
                                {adData.expiryDate?.toDate().toLocaleString()}
                            </p>

                            <button onClick={() => setShowReportModal(true)}>Report an Issue</button>

                        </div>

                        <div className="adDetailPageRight">
                            <p>Influencer details</p>

                            {advertiser && (
                                <>
                                    <div className="adDetailProfPic">
                                        <img
                                            src={advertiser.profileImage || defaultProfile}
                                            alt="profile"
                                        />
                                    </div>

                                    <h6>{advertiser.userName}</h6>
                                    <p>{advertiser.countryName}</p>
                                    <p>
                                        Joined:{' '}
                                        {advertiser.timestamp?.toDate().toLocaleDateString()}
                                    </p>
                                    <hr />
                                    <Link to={'/' + advertiser.theUsername} className='viewCreatorProf' target='_blank'>
                                        View Creator Profile
                                    </Link>
                                </>
                            )}
                        </div>
                    </div>

                    {reports.length > 0 && (
                        <div className="mt-4">
                            <h6>Reported Issues</h6>

                            <div className="reportList">
                                {reports.map((report, index) => (
                                    <div key={index} className="reportItem">
                                        <p><strong>Issue:</strong> {report.type}</p>
                                        {report.message && (
                                            <p><strong>Details:</strong> {report.message}</p>
                                        )}
                                        <small>
                                            Reported on:{' '}
                                            {report.createdAt?.toDate
                                                ? report.createdAt.toDate().toLocaleString()
                                                : new Date(report.createdAt).toLocaleString()}
                                        </small>
                                        <hr />
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}


                </section>
            </div>

            <div className="mobileOnly">
                <BottomNavUser />
            </div>

            <Modal show={showReportModal} onHide={() => setShowReportModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Report an Issue</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>What is the issue?</Form.Label>
                            <Form.Select
                                value={reportType}
                                onChange={(e) => setReportType(e.target.value)}
                            >
                                <option value="">Select an issue</option>
                                <option value="Influencer not responding">
                                    Influencer is not responding
                                </option>
                                <option value="Influencer not delivering">
                                    Influencer is not delivering
                                </option>
                                <option value="Mismatch with creator profile">
                                    What was advertised on creator profile is not being delivered
                                </option>
                                <option value="Other">Other</option>
                            </Form.Select>
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Additional details (optional)</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                value={reportMessage}
                                onChange={(e) => setReportMessage(e.target.value)}
                                placeholder="Describe the issue..."
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowReportModal(false)}>
                        Cancel
                    </Button>
                    <Button
                        variant="danger"
                        onClick={handleReportSubmit}
                        disabled={submittingReport}
                    >
                        {submittingReport ? "Submitting..." : "Submit Report"}
                    </Button>
                </Modal.Footer>
            </Modal>


        </div>
    )
}

export default UserViewSubs